import React, { createContext, useEffect, useRef, useState } from 'react';
import api from '../services/api';
import { toast } from 'react-toastify';
export const MarkContext = createContext({});

function MarksProvider({ children }) {

    const [marks, setMarks] = useState([])
    const [descriptionData, setDescription] = useState()

    const [showModalEdit, setShowModalEdit] = useState(false)
    const [modalEditValue, setModalEditValue] = useState()
    const [markName, setMarkName] = useState()

    const [exibirModal, setExibirModal] = useState(false)

    const getAll = async () => {
        const response = await api.get("panel/get/all/categorys")

        if (response.status == 200) {
            setMarks(response.data)
        }
    }

    const storage = async (name) => {


        if (!name) {
            return toast.error("Informe um nome da marca", {
                autoClose: 1500
            })
        }

        const response = await api.post("panel/storage/category", {
            name: name
        })

        if (response.status == 200) {
            getAll()
            return toast.success("Marca cadastrada com sucesso!", {
                autoClose: 1500
            })
        }

    }

    const remove = async (id) => {
        const response = await api.post("panel/delete/category", {
            id: id
        })

        if (response.status == 200) {
            getAll()
            return toast.success("Marca removida com sucesso!", {
                autoClose: 1500
            })
        }


    }

    const update = async (name, id) => {

        const response = await api.put("panel/update/category/", {
            id: modalEditValue,
            field: "name",
            value: name
        });

        if (response.status == 200) {
            getAll()
            return toast.success("Marca alterada com sucesso!", {
                autoClose: 1500
            })
        }

    }


    return (
        <MarkContext.Provider value={{
            getAll,
            marks,
            setDescription,
            descriptionData,
            setShowModalEdit,
            setModalEditValue,
            remove,
            storage,
            setMarkName,
            markName,
            setExibirModal,
            exibirModal,
            update

        }}>
            {children}
        </MarkContext.Provider>
    );
}

export default MarksProvider;
